import { HttpErrorResponse, HttpResourceRef } from "@angular/common/http";
import { effect, Signal, signal, WritableSignal } from "@angular/core";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";
import { debounceTime } from "rxjs";


export function triggerResource<TResource, TP1>(resource: (id: Signal<TP1 | undefined>) => HttpResourceRef<TResource>, p1: Signal<TP1 | undefined>) {
  let trigger = signal<TP1 | undefined>(undefined);
  let rx = resource(trigger);
  let obs$ = toObservable(rx.value);
  return {
    trigger, obs$, resource: rx, notFound: () => {
      const error = rx.error() as HttpErrorResponse;
      if (!error) {
        return false;
      }
      return error.status === 404;
    }
  };
}


export function toDebounceSignal<T>(
  sourceSignal: Signal<T>,
  debounceTimeInMs = 500
): Signal<T> {
  const debounceSignal = signal(sourceSignal());
  effect(
    (onCleanup) => {
      const value = sourceSignal();
      const timeout = setTimeout(
        () => debounceSignal.set(value),
        debounceTimeInMs
      );

      // The `onCleanup` argument is a function which is called when the effect
      // runs again (and when it is destroyed).
      // By clearing the timeout here we achieve proper debouncing.
      // See https://angular.io/guide/signals#effect-cleanup-functions
      onCleanup(() => clearTimeout(timeout));
    }
  );
  return debounceSignal;
}


